var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":'module-title-' + _vm.dModule.id}},[_c('div',{staticClass:"module-text ql-editor",domProps:{"innerHTML":_vm._s(_vm.dModule.data.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }